import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import DashboardHeader from "../../../../../components/dashboard/dashboardHeader";
import { ProjectCategoryForm } from "../../../../../components/dashboard/projects/categories/project-category-form";
import { ResourceLoading } from "../../../../../components/utils/ResourceLoading";
import { ResourceError } from "../../../../../components/utils/ResourceError";
import { fetchProjectCategory } from "../../../../../api/projectCategories";
import { mapErrors } from "../../../../../components/Utils";

export const EditProjectCategory = () => {
  const { t } = useTranslation();
  const { id } = useParams();

  const [itemState, setItemState] = useState({
    isLoading: true,
    error: false,
    errors: [],
    category: {},
  });

  const getCategory = async () => {
    return fetchProjectCategory(id)
      .then((res) => {
        if (res.data.id) {
          setItemState((prevState) => ({
            ...prevState,
            isLoading: false,
            category: res.data,
          }));
        }
      })
      .catch((err) => {
        let errors = null;
        if (err?.data?.errors) {
          errors = mapErrors(err.data.errors);
        } else {
          errors = ["Something went wrong"];
        }
        setItemState((prevState) => ({
          ...prevState,
          isLoading: false,
          category: {},
          error: true,
          errors: errors,
        }));
      });
  };

  useEffect(() => {
    getCategory();
  }, [id]);

  const handleOnRefresh = (data) => {
    if (data?.id) {
      setItemState((prevState) => ({
        ...prevState,
        category: data,
      }));
    } else {
      getCategory();
    }
  };

  const { isLoading, error, errors, category } = itemState;

  if (isLoading) {
    return <ResourceLoading />;
  }

  if (error && errors) {
    return <ResourceError errors={errors} />;
  }

  return (
    <>
      <DashboardHeader
        subtitle=""
        actions={[]}
        title="Edit Project Category"
        meta={[]}
      >
        <div className="mx-auto mt-8 grid max-w-3xl grid-cols-1 gap-6 sm:px-6 lg:max-w-7xl lg:grid-flow-col-dense lg:grid-cols-3">
          <div className="space-y-6 lg:col-span-3 lg:col-start-1 sm:col-span-3">
            <ProjectCategoryForm item={category} onRefresh={handleOnRefresh} />
          </div>
        </div>
      </DashboardHeader>
    </>
  );
};
